<template>
  <Card 
    v-if="prod"
    class="insu-prod-card"
  >
    <div
      slot="title"
      class="text-center"
    >
      <Radio 
        :value="val"
        @on-change="handleSelect(prod)"
      />
      <h3 class="main-title">{{ `${prod.insuCompany} ${prod.insuName}` }}</h3>
      <p class="premiums">{{ `${prod.premiums} 元` }} </p>
    </div>
      <div 
        v-for="list in prod.lists"
        :key="list.listId"
        
      >
        <h4 class="sub-title" :style="list.type.includes('強制')==false?list.type.includes('車體')==true?' color:rgb(73, 80, 96) ':'' :' color: rgb(24, 177, 100);' ">{{ list.type }}</h4>
        <ul>
          <li
            v-for="(item, index) in list.items"
            :key="index"
            class="clearfix"
          >
            <span v-text="item.title" />
            <span class="amount pull-right">{{ item.amount ? item.amount : '-' }}</span>
          </li>
        </ul>
      </div>
      <div class="insu-prod-card-footer">
        <Button 
          long
          size="large"
          :disabled="loading"
          @click="handleModal(prod)"
        >
          <Icon 
            type="eye"
            size="20"
          />更多細節
        </Button>
      </div>
  </Card>
</template>

<script>
  import { Card, Radio, Button, Icon } from 'iview';

  export default {
    components: { Card, Radio, Button, Icon },
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      prod: {
        type: Object,
        default: null
      },
      value: {
        type: Object,
        default: null
      },
      triggerModal: {
        type: Function,
        default: () => {}
      }
    },
    computed: {
      val() {
        return this.value ? this.value.insuId === this.prod.insuId : false;
      }
    },
    methods: {
      handleModal(prod) {
        const arr = [{ ...prod }];
        this.triggerModal(arr);
      },
      handleSelect(prod) {
        this.$emit('input', { ...prod });
      }
    }
  };
</script>